"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CMS_DISTRICT = exports.CMS_PROFESSIONAL = exports.CMS_STUDENT = exports.CMS_TEACHER = exports.CMS_COORDINATOR = exports.CMS_ADMIN = exports.isWidgetUser = exports.isAnyDistrict = exports.isDistrictSuperAdmin = exports.isDistrictFundingAdmin = exports.isDistrictAdmin = exports.isUnknown = exports.isPreview = exports.isPreviewStudent = exports.isPreviewTeacher = exports.isStudent = exports.isTeacher = exports.isCoordinator = exports.isAdmin = exports.isSDP = exports.isCSR = exports.isETS = exports.USER_UNKNOWN = exports.USER_PREVIEW_STUDENT = exports.USER_PREVIEW_TEACHER = exports.USER_DISTRICT_SUPER_ADMIN = exports.USER_DISTRICT_FUNDING_ADMIN = exports.USER_DISTRICT_ADMIN = exports.USER_ETS = exports.USER_SDP = exports.USER_CSR = exports.USER_STUDENT = exports.USER_TEACHER = exports.USER_COORDINATOR = exports.USER_ADMIN = void 0;
const USER_ADMIN = 'A';
exports.USER_ADMIN = USER_ADMIN;
const USER_COORDINATOR = 'C';
exports.USER_COORDINATOR = USER_COORDINATOR;
const USER_TEACHER = 'T';
exports.USER_TEACHER = USER_TEACHER;
const USER_STUDENT = 'S';
exports.USER_STUDENT = USER_STUDENT;
const USER_CSR = 'R';
exports.USER_CSR = USER_CSR;
const USER_SDP = 'D';
exports.USER_SDP = USER_SDP;
const USER_ETS = 'E';
exports.USER_ETS = USER_ETS;
const USER_DISTRICT_ADMIN = 'DA';
exports.USER_DISTRICT_ADMIN = USER_DISTRICT_ADMIN;
const USER_DISTRICT_FUNDING_ADMIN = 'DF';
exports.USER_DISTRICT_FUNDING_ADMIN = USER_DISTRICT_FUNDING_ADMIN;
const USER_DISTRICT_SUPER_ADMIN = 'DS';
exports.USER_DISTRICT_SUPER_ADMIN = USER_DISTRICT_SUPER_ADMIN;
const USER_PREVIEW_TEACHER = 'PT';
exports.USER_PREVIEW_TEACHER = USER_PREVIEW_TEACHER;
const USER_PREVIEW_STUDENT = 'ST';
exports.USER_PREVIEW_STUDENT = USER_PREVIEW_STUDENT;
const USER_UNKNOWN = 'U';
exports.USER_UNKNOWN = USER_UNKNOWN;

const isETS = function (role) {
  return role === USER_ETS;
};

exports.isETS = isETS;

const isCSR = function (role) {
  return role === USER_CSR;
};

exports.isCSR = isCSR;

const isSDP = function (role) {
  return role === USER_SDP;
};

exports.isSDP = isSDP;

const isAdmin = function (role) {
  return role === USER_ADMIN;
};

exports.isAdmin = isAdmin;

const isCoordinator = function (role) {
  return role === USER_COORDINATOR;
};

exports.isCoordinator = isCoordinator;

const isTeacher = function (role) {
  return role === USER_TEACHER;
};

exports.isTeacher = isTeacher;

const isStudent = function (role) {
  return role === USER_STUDENT;
};

exports.isStudent = isStudent;

const isPreviewTeacher = function (role) {
  return role === USER_PREVIEW_TEACHER;
};

exports.isPreviewTeacher = isPreviewTeacher;

const isPreviewStudent = function (role) {
  return role === USER_PREVIEW_STUDENT;
};

exports.isPreviewStudent = isPreviewStudent;

const isPreview = function (role) {
  return isPreviewTeacher(role) || isPreviewStudent(role);
};

exports.isPreview = isPreview;

const isUnknown = function (role) {
  return role === USER_UNKNOWN;
};

exports.isUnknown = isUnknown;

const isDistrictAdmin = function (role) {
  return role === USER_DISTRICT_ADMIN;
};

exports.isDistrictAdmin = isDistrictAdmin;

const isDistrictFundingAdmin = function (role) {
  return role === USER_DISTRICT_FUNDING_ADMIN;
};

exports.isDistrictFundingAdmin = isDistrictFundingAdmin;

const isDistrictSuperAdmin = function (role) {
  return role === USER_DISTRICT_SUPER_ADMIN;
};

exports.isDistrictSuperAdmin = isDistrictSuperAdmin;

const isAnyDistrict = function (role) {
  return role === USER_DISTRICT_ADMIN || role === USER_DISTRICT_FUNDING_ADMIN || role === USER_DISTRICT_SUPER_ADMIN;
};

exports.isAnyDistrict = isAnyDistrict;

const isWidgetUser = function (role) {
  return isStudent(role) || isAdmin(role) || isCoordinator(role) || isTeacher(role) || isUnknown(role) || isAnyDistrict(role) || isPreview(role);
};

exports.isWidgetUser = isWidgetUser;
const CMS_ADMIN = 'admin';
exports.CMS_ADMIN = CMS_ADMIN;
const CMS_COORDINATOR = 'coordinator';
exports.CMS_COORDINATOR = CMS_COORDINATOR;
const CMS_TEACHER = 'teacher';
exports.CMS_TEACHER = CMS_TEACHER;
const CMS_STUDENT = 'student';
exports.CMS_STUDENT = CMS_STUDENT;
const CMS_PROFESSIONAL = 'professional';
exports.CMS_PROFESSIONAL = CMS_PROFESSIONAL;
const CMS_DISTRICT = 'district';
exports.CMS_DISTRICT = CMS_DISTRICT;